import { forwardRef } from 'react';

export const Micro = forwardRef<HTMLDivElement, { id: string; html: string }>(
  ({ id, html }, ref) => {
    return (
      <div
        data-micro-server={id}
        dangerouslySetInnerHTML={{ __html: html }}
        ref={ref}
      />
    );
  },
);
